export default {"src":"/_next/static/media/us.14a0c5b4.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};